export const updateQueryString = (updatedParams: { [key: string]: string | null }) => {
  const params = new URLSearchParams(window.location.search);
  Object.entries(updatedParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.set(key, value);
    }
  });
  window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
};

export const removeQueryParameters = (url: string) => url.split('?')[0];

export const compareBasePath = (path1: string, path2: string) => removeQueryParameters(path1) === removeQueryParameters(path2);
